module.exports = __webpack_public_path__ + "assets/img/flamengo1.66d24063.png";